import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalModule } from 'snl-complib';
import { NotesComponent } from "../notes/notes.component";

@Component({
  selector: 'app-notes-popup',
  standalone: true,
  imports: [ModalModule, NotesComponent],
  templateUrl: './notes-popup.component.html',
  styleUrl: './notes-popup.component.scss'
})
export class NotesPopupComponent {
  public modalSettings: any;
  @Input() open: boolean = false;
  @Input() selectedTab: string = '';
	@Input() ccdNo:string | null = null;
	@Input() accessOfNotesEditor:boolean = false;
  @Output() onButtonClick: EventEmitter<any | null> = new EventEmitter();

  ngOnInit() {
    this.modalSettings = { showCloseIcon: true, backdropClick: false };
  }

  closeModalPopUp() {
    this.onButtonClick.emit({}) 
  }
}
